import React from 'react'
// libs
import styled from 'styled-components'
import { InjectedFormProps, reduxForm } from 'redux-form'
// components
import { ReduxInput } from 'components/FormElements/ReduxForm'
// view components
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// constants
import { Forms } from 'constants/forms'
// icons
import { CloseIcon } from 'components/UI/Icons'
// themes
import colors from 'themes/colors'
// utils
import { required } from 'utils/validators'

// styled
const Header = styled.div`
  color: ${colors.blue500};
  font-size: 16px;
  font-weight: bold;
  position: relative;
  height: 32px;
  border-bottom: 1px solid ${colors.blue500};
`

const Form = styled.form`
  margin: 15px;

  > p {
    margin: 15px 0 0 0;
    padding: 0;
    color: ${colors.gray300};
    font-size: small;
`

// types
interface IIncomingProps {
  hideModal: () => void
}

type IProps = IIncomingProps & InjectedFormProps<{}, IIncomingProps>

const AddLinkForm: React.FunctionComponent<IProps> = ({ hideModal, handleSubmit }) => {
  return (
    <Form onSubmit={handleSubmit}>
      <Header>
        Add Link
        <CloseIcon right={0} onClick={hideModal} />
      </Header>
      <p>Link target</p>
      <ReduxInput name={'linkTarget'} validate={[required]} />
      <p>Link name</p>
      <ReduxInput name={'linkName'} />
      <Button type={'submit'} layout={BUTTON_LAYOUTS.PURPLE} shadowLess style={{ borderRadius: 20, marginTop: 15 }}>
        Save
      </Button>
    </Form>
  )
}

export default reduxForm<{}, IIncomingProps>({ form: Forms.ADD_LINK_FOR_ACTIVITY_FORM })(AddLinkForm)
